<template>
<div class="" style="position: absolute; font-size: 13px; top: 75px; height: 189px; left: 0px; background-color: white"  :style="elementStyle('additional-info')">
  <div v-if="!isSelectedImportDMS && !isSelectedImportCSV" id="sticky-additional-info"
       class="d-flex flex-row align-items-center justify-content-between additional-info flex-wrap rfq-view-additional-info">
    <div class="d-flex align-items-center">
      <vin-date :vin="rfq.vehicle.vin"
                :date="rfq.vehicle.dom ? rfq.vehicle.dom : ''"
                :hideTrackCode="true"></vin-date>
      <template v-if="isRfqToUsed">
        <div class="vehicle-details-information-block">
          <p>Rego: {{ rfq.vehicle.rego }}</p>
          <p>Make: {{ rfq.vehicle.make }}</p>
          <p>Model: {{ rfq.vehicle.model }}</p>
          <p>Series: {{ rfq.vehicle.series }}</p>
          <p>Body: {{ rfq.vehicle.body }}</p>
        </div>
      </template>
      <template v-if="rfq && rfq.properties && rfq.properties.isAskForPaintCode">
        <b-form-group label="Paint Code"
                      label-for="paint-code"
                      class="m-0 paint-code d-flex align-items-center"
                      style="padding-top:5px"
                      label-cols="auto">
          <b-form-input ref="paint-code-field"
                        id="paint-code"
                        class="paint-code-input"
                        @focus="$emit('onFocusPaintCode')"
                        @blur="$emit('onBlurPaintCode')"
                        :class="{ 'border-for-paint-code': isFlashingPaintCode}"
                        style="width: 138px; font-size: 10px; background-color: rgba(41, 187, 193, 0.1);"
                        v-model="rfq.paintCodeForRepair"
                        @change="$emit('updatePaintCodeForRepair')">
          </b-form-input>
          <div v-if="showPlaceholderPaintCode" @click="$emit('onFocusPaintCode')" class="paint-code-placeholder">Paint
            Code Requested
          </div>
        </b-form-group>
      </template>
    </div>
    <div class="d-flex px-15  flex-wrap">
      <b-form-group v-if="rfq && rfq.properties && rfq.properties.isEnableNillStock"
                    label="Claim Nbr:"
                    label-for="quote-nbr-field"
                    class="m-0  quote-nbr d-flex align-items-center"
                    style="padding-top:5px"
                    label-cols="auto">
        <b-form-input id="quote-nbr-field"
                      style="width: 138px;"
                      :disabled="false"
                      @change="$emit('saveClaimNbr')"
                      v-model="rfq.claimNumber"
                      @focus="$emit('onFocusOrBlurClaimNbr', true)"
                      @blur="$emit('onFocusOrBlurClaimNbr', false)"
                      class="font-13">
        </b-form-input>
      </b-form-group>
      <template v-if="isAdditionalRfq && isHasPreviousNbrs">
        <div class="d-flex flex-column" style="padding-bottom: 0px !important; padding-top: 20px">
          <b-form-group label="Quote Nbr:"
                        label-for="quote-nbr-field"
                        class="m-0  quote-nbr d-flex align-items-center"
                        style="padding:2px 0;"
                        label-cols="auto">
            <b-form-input id="quote-nbr-field"
                          style="width: 138px; margin-right: 10px; margin-left: 10px;"
                          class="font-13"
                          :disabled="!(isRFQNew || (isRFQPriced && priceResubmitActiveFlag)) || isLockedRfq"
                          @focus="isQuoteNbrFocus = true; isQuoteNbrFocus2 = true"
                          @blur="isQuoteNbrFocus2 = false"
                          v-closable2="{
                                exclude: ['quoteNbrsDropdown2'],
                                handler: 'onQuoteNbrBlur'
                              }"
                          v-model="rfq.supplierQuoteNumber"
                          autocomplete="off"
                          @change="$emit('updateSupplierQuoteNumber')">
            </b-form-input>
            <i
                v-if="!isEmpty(computedUpdatedQuoteNbr)"
                class="bx bx-refresh blinking-green"
                v-b-tooltip.hover="{customClass: 'ps-tooltip', title: ' Update Received <br/>' + formatDate(computedUpdatedQuoteNbr.datetime), html: true, placement:'leftbottom'}"
            ></i>
            <div ref="quoteNbrsDropdown2" class="quote-number-menu"
                 v-if="!isEmpty(quoteNumbersFiltered) && isQuoteNbrFocus && !rfq.undoAvailable">
              <div v-for="(nbr, key) in quoteNumbersFiltered" :key="key"
                   class="quote-number-menu-item d-flex justify-content-between"
                   @click="selectQuoteNbr(nbr)">
                <span>{{ nbr }}</span>
                <i @click="$emit('removeQuoteNbr', nbr)" class="bx bx-trash quote-number-close"></i>
              </div>
            </div>
          </b-form-group>
          <div v-if="isHasPreviousNbrs" class="previous-quote" style="color: red; padding-left: 3px">Previous Quote: <span style="font-weight: bold">{{rfq.supplierPreviousQuoteNumbers[0]}}</span></div>
        </div>

      </template>
      <template v-else>
        <b-form-group label="Quote Nbr:"
                      label-for="quote-nbr-field"
                      class="m-0  quote-nbr d-flex align-items-center"
                      style="padding:2px 0;"
                      label-cols="auto">
          <b-form-input id="quote-nbr-field"
                        style="width: 138px; margin-right: 10px; margin-left: 10px;"
                        class="font-13"
                        :disabled="!(isRFQNew || (isRFQPriced && priceResubmitActiveFlag)) || isLockedRfq"
                        @focus="isQuoteNbrFocus = true; isQuoteNbrFocus2 = true"
                        @blur="isQuoteNbrFocus2 = false"
                        v-closable2="{
                                exclude: ['quoteNbrsDropdown2'],
                                handler: 'onQuoteNbrBlur'
                              }"
                        v-model="rfq.supplierQuoteNumber"
                        autocomplete="off"
                        @change="$emit('updateSupplierQuoteNumber')">
          </b-form-input>
          <i
              v-if="!isEmpty(computedUpdatedQuoteNbr)"
              class="bx bx-refresh blinking-green"
              v-b-tooltip.hover="{customClass: 'ps-tooltip', title: ' Update Received <br/>' + formatDate(computedUpdatedQuoteNbr.datetime), html: true, placement:'leftbottom'}"
          ></i>
          <div ref="quoteNbrsDropdown2" class="quote-number-menu"
               v-if="!isEmpty(quoteNumbersFiltered) && isQuoteNbrFocus && !rfq.undoAvailable">
            <div v-for="(nbr, key) in quoteNumbersFiltered" :key="key"
                 class="quote-number-menu-item d-flex justify-content-between"
                 @click="selectQuoteNbr(nbr)">
              <span>{{ nbr }}</span>
              <i @click="$emit('removeQuoteNbr', nbr)" class="bx bx-trash quote-number-close"></i>
            </div>
          </div>
        </b-form-group>
      </template>
      <b-form-group label="Order Nbr:"
                    v-if="isRFQWon"
                    class="m-0  quote-nbr d-flex align-items-center rfq-order-nbr-group"
                    style="padding:2px 0; margin-bottom: 0px !important;"
                    label-cols="auto">
                <span id="quote-nbr-field"
                      @click="$emit('viewOrder')"
                      style="width: 138px; margin-right: 10px; margin-left: 0px; transform: translateY(5px)"
                      class="font-13 rfq-order-number">
                  {{ rfq.order.number}}
                </span>
        <i
            v-if="!isEmpty(computedUpdatedQuoteNbr)"
            class="bx bx-refresh blinking-green"
            v-b-tooltip.hover="{customClass: 'ps-tooltip', title: ' Update Received <br/>' + formatDate(computedUpdatedQuoteNbr.datetime), html: true, placement:'leftbottom'}"
        ></i>
        <div ref="quoteNbrsDropdown2" class="quote-number-menu"
             v-if="!isEmpty(quoteNumbersFiltered) && isQuoteNbrFocus && !rfq.undoAvailable">
          <div v-for="(nbr, key) in quoteNumbersFiltered" :key="key"
               class="quote-number-menu-item d-flex justify-content-between"
               @click="selectQuoteNbr(nbr)">
            <span>{{ nbr }}</span>
            <i @click="$emit('removeQuoteNbr', nbr)" class="bx bx-trash quote-number-close"></i>
          </div>
        </div>
      </b-form-group>
      <b-form-group label="Repairer Quote Nbr:"
                    label-for="quote-nbr-field"
                    class="m-0  quote-nbr d-flex align-items-center"
                    style="padding:2px 0"
                    label-cols="auto">
        <b-form-input id="quote-nbr-field"
                      style="width: 138px; margin-left: 10px;"
                      :disabled="true"
                      class="font-13"
                      :value="isAdditionalRfq ? 'Addition to ' + rfq.repairerQuoteNumber :  rfq.repairerQuoteNumber">
        </b-form-input>
      </b-form-group>

    </div>
  </div>

  <div class="d-flex">
    <div v-if="!isSelectedImportDMS && !isSelectedImportCSV" id="supplier-rfq-view-thead-wrapper"  style="overflow-x: auto; overflow-y: hidden; margin-left: 15px; padding-right: 7px" :style="{width: getWidth('supplier-rfq-view-table') + 'px'}" @scroll="onScroll">
      <div class=""  :style="elementStyle('supplier-rfq-view-thead')">
        <div class="sticky-rfq-view-header">
          <div class="part-list-line sticky-rfq-view-header-item d-flex flex-column justify-content-center"  :style="elementStyle('supplier-rfq-view-line-column')" style="background: #e3e4e7 !important; position: sticky; left: 0px; z-index: 5">
            Line
          </div>
          <div class="part-list-part-name sticky-rfq-view-header-item d-flex flex-column justify-content-center" :style="elementStyle('supplier-rfq-view-part-list-column')" style="background: #e3e4e7 !important; position: sticky; z-index: 5" >
            <div class="d-flex">
              Part List
              <span @click="rfq.sortBy('name')"></span></div>
          </div>
          <div v-if="isShowOePartNumberColumn" class="part-list-number text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" :style="elementStyle('supplier-rfq-view-oem-part-number-column')" style="position: relative; z-index: 1;">
         <div class="d-flex">
           OE Part Number
           <span v-if="!isNewStatus" @click="rfq.sortBy('oemPartNumber')"></span>
         </div>
       </div>
       <div v-if="isShowOePartNumberColumn" class="part-list-number text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" :style="elementStyle('supplier-rfq-view-oe-part-number-column')" style="position: relative; z-index: 1;">
         <div class="d-flex">
           OE Reference Number
           <span v-if="!isNewStatus" @click="rfq.sortBy('oePartNumber')"></span>
         </div>
       </div>
       <div class="part-list-number text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" :style="elementStyle('supplier-rfq-view-part-number-column')" style="position: relative; z-index: 1;">
            <div class="d-flex">
              Part Number
              <span v-if="!isNewStatus" @click="rfq.sortBy('partNumber')"></span>
            </div>
          </div>
          <div
              class="part-list-in-stock text-center sticky-rfq-view-header-item"
              id="sticky-stock-column" :style="elementStyle('supplier-rfq-view-stock-column')"
              :class="{
             'd-flex flex-column justify-content-center align-items-center': !(isNewStatus || priceResubmitFlag) || true
           }"
              style="">
            <div v-if="!(isNewStatus || priceResubmitFlag)">
              <div class="d-flex">
                <p>In Stock</p>
                <span v-if="!isNewStatus" @click="rfq.sortBy('status')"
                      style="top: 43px; left: 140px;"></span>
              </div>
            </div>
            <div v-else>
              <p class="m-0" >Stock Status</p>
              <template>

              </template>
            </div>

            <div class="" style="position: absolute; width: 145px;" :style="{bottom: getBottomStockSelect()}" v-if="(isNewStatus || priceResubmitFlag)" id="rfq-stock-all-wrapper">
              <stock-select
                  :id="0"
                  :options="stockOptions"
                  v-model="stockForAll"
                  :is-disabled="isDisabledFields"
                  :isNeedDateRange="true"
                  :isStockAll="true"
                  @onSelected="v => $emit('selectedAllStock', v)"
                  class="stock-select-header"
              >
              </stock-select>
            </div>

          </div>
          <div class="part-list-qty text-center d-flex flex-column justify-content-center sticky-rfq-view-header-item align-items-center" style="position: relative; z-index: 1;"  :style="elementStyle('supplier-rfq-view-qty-column')">
            <div class="d-flex">
              Qty
              <span @click="rfq.sortBy('qty')"></span>
            </div>
          </div>
          <div v-if="isRfqToOemGen" class="part-list-rrp text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" style="position: relative; z-index: 1;" :style="elementStyle('supplier-rfq-view-rrp-column')">
            <div class="d-flex">
              List
              <span @click="rfq.sortBy('rrp')"></span>
            </div>
          </div>
          <div
              class="part-list-company text-center sticky-rfq-view-header-item"
              :class="{'supplier-selected-column': isColumnClicked(companyInfo.id)}"
              @click="setClickedSupplier(companyInfo.id)"
              @mouseover="setActiveSupplier(companyInfo.id, isRfqToOemGen ? 7 : 6)"
              @mouseleave="setActiveSupplier(null, null)"
              style="position: relative; z-index: 1;"
              :style="elementStyle('supplier-rfq-view-supplier')">
            <div class="supplier-name text-center">
              <template v-if="isMultipleLocations">
                {{ rfq.supplierBusinessName }}
              </template>
              <template v-else>
                {{ companyInfo.businessName }}
              </template>
            </div>
            <div class="supplier-icon text-center">
              <img v-if="1==-1" :src="companyInfo.logoImgPath">
              <template v-if="isRFQPriced && isExistRequestBestPrice">
                <i
                    v-if="isLockedSupplierMain()"
                    class='bx bx-lock-alt' style="color: #bd5008;"
                    v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                    html: true,
                    title: 'This suppliers pricing is locked in.',
                    placement:'righttop',
                  }"></i>
                <i
                    v-if="isUnLockedSupplierMain()"
                    v-b-tooltip.hover="{
                      customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                      html: true,
                      title: '<b>Pricing field Unlocked,</b> Customers will see changes instantly.',
                      placement:'righttop',
                    }"
                    class='bx bx-lock-open-alt'
                    style="color: #4b8823;"></i>
              </template>
            </div>
            <div class="supplier-type text-center">
              {{ rfq.partsType }}
            </div>
            <div class="part-list-company-color" :style="{ background: getSupplierColor({type: rfq.partsType}) }"></div>
          </div>

          <div
              v-if="rfq.isRebateEnabled"
              style="position: relative; z-index: 1;"
              class="part-list-company text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center"
              @mouseover="setActiveSupplier('rebate', isRfqToOemGen ? 8 : 7)"
              @mouseleave="setActiveSupplier(null, null)"
              :style="elementStyle('supplier-rfq-view-rebate')">
            <div class="supplier-icon text-center">
            </div>
            <div style="min-height: 18px" class="supplier-name text-center">
              Rebate
            </div>
            <div class="supplier-type text-center">
              {{ rfq.partsType }}
            </div>
            <div class="part-list-company-color" :style="{ background: getSupplierColor({type: rfq.partsType}) }"></div>
          </div>


          <!-- Other suppliers block -->
          <div
              v-for="(supplier, ind) in filterSuppliers()"
              :key="supplier.id" :style="elementStyle('supplier-rfq-view-supplier-' + supplier.id)"
              @click="setClickedSupplier(supplier.id)"
              :class="{'supplier-selected-column': isColumnClicked(supplier.id)}"
              @mouseover="setActiveSupplier(supplier.id, getColumnIndex(ind))"
              @mouseleave="setActiveSupplier(null, null)"
              style="position: relative; z-index: 1;"
              class="part-list-company-other text-center sticky-rfq-view-header-item">
            <div class="supplier-name text-center">
              {{ supplier.name }}
              <div
                  v-if="supplier.isNonRegistered"
                  v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip supplier-icon-ps-tooltip-error non-reg-tooltip',
                    html: true,
                    title: '<b>Non-Registered Supplier.</b> This supplier has been added by the customer. The customer will add proof of pricing before ordering',
                    placement:'righttop',
                  }"
                  style="color: red">
                Non-Registered
              </div>
            </div>
            <div class="supplier-icon text-center">
              <img v-if="1==-1" :src="companyInfo.logoImgPath">
              <template v-if="isRFQPriced && isExistRequestBestPrice">
                <i
                    v-if="isLockedSupplier(supplier)"
                    class='bx bx-lock-alt' style="color: #bd5008;"
                    v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                    html: true,
                    title: supplier.isNonRegistered ? '<b>Pricing Locked.</b> This will not change while the RFQ is open again.' : 'This suppliers pricing is locked in.',
                    placement:'righttop',
                  }"></i>
                <i class='bx bx-error' style="color: #bd5008;"
                   v-if="supplier.isNonRegistered"
                   v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip supplier-icon-ps-tooltip-error',
                    html: true,
                    title: 'Repairer has shared pricing from a Non registered supplier.',
                    placement:'righttop',
                  }"></i>
                <i
                    v-if="supplier.isNonRegistered && supplier.pdfFile && supplier.pdfFile.src"
                    @click="$emit('selectedPdf', supplier.pdfFile.src)"
                    class='bx bxs-file-pdf'
                    v-b-tooltip.hover="{
                        customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                        html: true,
                        title: '<b>View PDF pricing</b> proof added by the customer',
                        placement:'righttop',
                      }"
                    style="color: #bd5008;"></i>
                <i
                    v-if="isUnLockedSupplier(supplier)"
                    v-b-tooltip.hover="{
                      customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                      html: true,
                      title: '<b>Pricing field Unlocked,</b> Customers will see changes instantly.',
                      placement:'righttop',
                    }"
                    class='bx bx-lock-open-alt' style="color: #4b8823;"></i>
              </template>
              <template v-if="(isNewStatus || (isRFQPriced && !isExistRequestBestPrice)) && supplier.isNonRegistered">
                <i class='bx bx-error' style="color: #bd5008;"
                   v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip supplier-icon-ps-tooltip-error',
                    html: true,
                    title: '<b>Non-Registered Supplier.</b> This supplier has been added by the customer. The customer will add proof of pricing before ordering',
                    placement:'righttop',
                  }"></i>
                <i
                    v-if="supplier.pdfFile && supplier.pdfFile.src"
                    @click="$emit('selectedPdf', supplier.pdfFile.src)"
                    class='bx bxs-file-pdf'
                    v-b-tooltip.hover="{
                        customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                        html: true,
                        title: '<b>Click to view</b> PDF added by the repairer',
                        placement:'righttop',
                      }"
                    style="color: #bd5008;"></i>
              </template>
            </div>
            <div class="supplier-type text-center">
              {{ supplier.type }}
            </div>
            <div class="part-list-company-color" :style="{ background: getSupplierColor(supplier), width: (getWidthForElement('supplier-rfq-view-supplier-' + supplier.id) - 5) + 'px' }"></div>
          </div>

          <div class="part-list-gst text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" style="position: relative; z-index: 1;" :style="elementStyle('supplier-rfq-view-gst')">
            <div class="d-flex">
              GST
              <span @click="rfq.sortBy('gst')"></span>
            </div>
          </div>
          <div class="part-list-total text-center sticky-rfq-view-header-item d-flex flex-column justify-content-center align-items-center" style="position: relative; z-index: 1;" :style="elementStyle('supplier-rfq-view-total')">
            <div class="d-flex">
              Total
              <span @click="rfq.sortBy('total')"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="isShowDirectComment && ((rfq && rfq.directOrder && rfq.directOrder.comment && _isEmpty(rfq.suppliers)) || (isRfqToOemGen && rfq.properties.isAskForPartsDiagram))">

      <template v-if="rfq && rfq.properties && rfq.properties.isSentAsDirectOrder && !(isRfqToOemGen && rfq.properties.isAskForPartsDiagram)">
        <div id="sticky-direct-comment" style="position: absolute; background: white" :style="{width: getDirectBlockWidth(), left: getWidth('supplier-rfq-view-table') + 14 + 'px'}" class="rfq-view-direct-order-comment direct-commnet-block"  v-html="rfq.directOrder.comment"></div>
      </template>

      <template v-else>
        <template v-if="(rfq && rfq.properties && rfq.properties.isAskForPartsDiagram)">
          <template v-if="isRfqToOemGen">
            <div id="sticky-direct-comment" style="position: absolute; background: white" class="send-direct-order-comment-block direct-commnet-block" :style="{width: getDirectBlockWidth(), height: getDirectBlockHeight(), left: getWidth('supplier-rfq-view-table') + 14 + 'px'}">

              <template v-if="rfq && rfq.properties && rfq.properties.isSentAsDirectOrder">
                <div class="rfq-view-direct-order-comment direct-commnet-block rfq-view-direct-order-comment-2"  v-html="rfq.directOrder.comment"></div>
              </template>

              <div class="p-2">
                <div class="pb-3" :class="{'pt-3': rfq.properties.isSentAsDirectOrder}"><b>PARTS DIAGRAM REQUEST</b></div>
                <div class="pb-1">
                  <span style="font-weight: 600;">Comment: </span>
                </div>
                {{ rfq.vehicle.comments }}
              </div>
            </div>
          </template>
        </template>
      </template>

    </template>
  </div>
</div>
</template>

<script>
import VinDate from '../../../../components/VinDate'
import moment from "moment";
import StockSelect from '../../../../components/StockSelect'
import {States} from "../../../../store/states";
import {mapGetters} from "vuex";
import _ from "lodash";
import Vue from "vue";
let handleOutsideClick
Vue.directive('closable2', {
  bind (el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          let excludedEl = vnode.context.$refs[refName]
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            if (excludedEl._isVue) {
              excludedEl = excludedEl.$el
            }
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        }
      })
      // console.log(e.target)
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

export default {
  name: "rfq-view-sticky-header",
  components: {
    VinDate,
    StockSelect
  },
  props: {
    isSelectedImportDMS: {
      type: Boolean,
      default: false,
    },
    isShowDirectComment: {
      type: Boolean,
      default: false,
    },
    isSelectedImportCSV: {
      type: Boolean,
      default: false,
    },
    isFlashingPaintCode: {
      type: Boolean,
      default: false,
    },
    showPlaceholderPaintCode: {
      type: Boolean,
      default: false,
    },
    isAdditionalRfq: {
      type: Boolean,
      default: false,
    },
    isNewStatus: {
      type: Boolean,
      default: false,
    },
    priceResubmitFlag: {
      type: Boolean,
      default: false,
    },
    isRFQNew: {
      type: Boolean,
      default: false,
    },
    isRFQPriced: {
      type: Boolean,
      default: false,
    },
    isRFQWon: {
      type: Boolean,
      default: false,
    },
    priceResubmitActiveFlag: {
      type: Boolean,
      default: false,
    },
    isLockedRfq: {
      type: Boolean,
      default: false,
    },
    activeSupplierId: {
      type: [Object, Number, String],
      default: null,
    },
    clickedSupplierId: {
      type: [Object, Number, String],
      default: null,
    },
    activeColumnIndex: {
      type: [Object, Number, String],
      default: null,
    },
    rfq: {
      type: Object,
      default() {
        return {}
      }
    },
    computedUpdatedQuoteNbr: {
      type: Object,
      default() {
        return {}
      }
    },
    quoteNumbersFiltered: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      stockOptions: States.stockOptions,
      stockForAll: { 'label': 'Set All', 'textValue': 'selectAll', 'value': -1, 'comment': '' },
      columnWidths: {},
      columnHeight: {},
      columnPadding: {},
      leftPositions: {},
      isQuoteNbrFocus: false,
      isQuoteNbrFocus2: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.setColumnSize);
    window.addEventListener('scroll', this.setColumnSize);
    let el = document.getElementById('supplier-rfq-view-table')
    el.addEventListener('scroll', this.onTableScroll)
    this.setColumnSize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setColumnSize);
    window.removeEventListener('scroll', this.setColumnSize);
  },
  methods: {
    isLockedSupplier(supplier) {
      return supplier.isNonRegistered || (supplier.thirdRequestBestPrice === false || (supplier.secondRequestBestPrice === false && supplier.thirdRequestBestPrice !== false && supplier.thirdRequestBestPrice !== true))
    },
    isUnLockedSupplier(supplier) {
      return !supplier.isNonRegistered && (supplier.thirdRequestBestPrice === true || supplier.secondRequestBestPrice === true)
    },
    isLockedSupplierMain() {
      return  (this.rfq?.thirdRequestBestPrice === false || (this.rfq?.secondRequestBestPrice === false && this.rfq?.thirdRequestBestPrice !== false && this.rfq?.thirdRequestBestPrice !== true))
    },
    isUnLockedSupplierMain() {
      return (this.rfq?.thirdRequestBestPrice === true || this.rfq?.secondRequestBestPrice === true)
    },
    getBottomStockSelect() {
      let r = 5;
      // let el = document.getElementById('supplier-rfq-view-thead')
      // let el2 = document.getElementById('sticky-direct-comment')
      // if (el && el2) {
      //   let d = el2.clientHeight - el.clientHeight;
      //   if (d > 0) {
      //     r += d
      //   }
      // }
      return r + 'px'
    },
    getDirectBlockHeight() {
      let el = document.getElementById('comments-label')
      if (!el){
        return
      }
      return el.clientHeight + 'px'
    },
    getDirectBlockWidth() {
      let el = document.getElementById('supplier-rfq-view-table')
      let el2 = document.getElementsByClassName('site-sidebar')[0]
      if (!el || !el2){
        return
      }
      let place = window.innerWidth - el.clientWidth - el2.clientWidth;
      if (place >= 270) {
        if (place <= 410) {
          return (place - 30) + 'px'
        } else {
          return '380px'
        }
      }
      return '0px'
    },
    _isEmpty(v) {
      return _.isEmpty(v)
    },
    getColumnIndex(ind) {
      ind += 7
      if (this.isRfqToOemGen) {
        ind += 1
      }
      if (this.rfq.isRebateEnabled) {
        ind += 1
      }
      return ind
    },
    setActiveSupplier (id, index) {
      this.$emit('changedActiveSupplierId', id)
      this.$emit('changedActiveColumnIndex', index)
    },
    setClickedSupplier (id) {
      let val = null
      if (this.clickedSupplierId !== id) {
        val = id;
      }
      this.$emit('changedClickedSupplierId', val)
    },
    isColumnClicked(id) {
      return id === this.clickedSupplierId
    },
    isActiveColumn (id) {
      return id === this.activeSupplierId
    },
    onScroll() {

      this.$nextTick(() => {
        let el = document.getElementsByClassName("b-table-sticky-header")[0];
        let el2 = document.getElementById("supplier-rfq-view-thead-wrapper");
        if (el2 && el) {
          el.scrollLeft = el2.scrollLeft;
          let stockAll = document.getElementById("rfq-stock-all-wrapper");
          if (stockAll) {
            stockAll.style.transform = `translateX(-${el2.scrollLeft}px)`
          }
        }
      })
    },
    getSupplierColor(supplier){
      switch (supplier.type){
        case 'OEM-GEN':
          return '#083d77'
        case 'OEM-PAR':
          return '#ee964b'
        case 'OEM-ALT':
          return '#f4d35e'
        case 'CERT-AFTM':
          return '#fa7a61'
        case 'AFTM':
          return '#6b8f71'
        case 'USED':
          return '#b287a3'
        case 'RECO':
          return '#57b8ff'

        default:
          return '#a3a3a3'
      }
    },
    selectQuoteNbr(nbr) {
      this.onQuoteNbrBlur()
      this.$emit('selectQuoteNbr', nbr)
    },
    onQuoteNbrBlur() {
      if (this.isQuoteNbrFocus2) {
        return
      }
      setTimeout(() => {
        this.isQuoteNbrFocus = false
        this.isQuoteNbrFocus2 = false
      }, 100)
    },
    onTableScroll() {
      let el = document.getElementById("supplier-rfq-view-table");
      let el2 = document.getElementById("supplier-rfq-view-thead-wrapper");
      if (el2) {
        el2.scrollLeft = el.scrollLeft;
      }
    },
    setLeftPosition() {
      // let lineWidth = document.getElementById('supplier-rfq-view-line-column').clientWidth;
      // let partListWidth = document.getElementById('supplier-rfq-view-part-list-column').clientWidth;
      // let partNumberWidth = document.getElementById('supplier-rfq-view-part-number-column').clientWidth;
      // let qtyWidth = document.getElementById('supplier-rfq-view-qty-column').clientWidth;
      // // let rrpWidth = document.getElementById('supplier-rfq-view-rrp-column').clientWidth;
      //
      // this.$nextTick(() => {
      //   this.$set(this.leftPositions, 'supplier-rfq-view-line-column', '0px')
      //   this.$set(this.leftPositions, 'supplier-rfq-view-part-list-column', lineWidth + 'px')
      //   this.$set(this.leftPositions, 'supplier-rfq-view-part-number-column', lineWidth + partListWidth + 'px')
      //   this.$set(this.leftPositions, 'supplier-rfq-view-qty-column', lineWidth + partListWidth + partNumberWidth + 'px')
      //   this.$set(this.leftPositions, 'supplier-rfq-view-rrp-column', lineWidth + partListWidth + partNumberWidth + qtyWidth + 'px')
      // })
    },
    setColumnSize() {

      this.setLeftPosition()
      let ids = ['additional-info', 'supplier-rfq-view-thead', 'supplier-rfq-view-line-column', 'supplier-rfq-view-part-list-column',
        'supplier-rfq-view-stock-column', 'supplier-rfq-view-part-number-column', 'supplier-rfq-view-qty-column', 'supplier-rfq-view-supplier',
        'supplier-rfq-view-gst', 'supplier-rfq-view-total']
      _.forEach(this.filterSuppliers(), (s) => {
        ids.push('supplier-rfq-view-supplier-' + s.id)
      })
      if (this.rfq.isRebateEnabled) {
        ids.push('supplier-rfq-view-rebate')
      }
      if (this.isShowOePartNumberColumn) {
        ids.push('supplier-rfq-view-oem-part-number-column')
        ids.push('supplier-rfq-view-oe-part-number-column')
      }
      if (this.isRfqToOemGen) {
        ids.push('supplier-rfq-view-rrp-column')
      }

      _.forEach(ids, (id) => {
        this.$nextTick(() => {
          this.$set(this.columnWidths, id, this.getWidth(id))
          this.$set(this.columnHeight, id, this.getHeight(id))
          this.$set(this.columnPadding, id, this.getPadding(id))
        })
        // this.columnWidths[id] = this.getWidth(id)
      })
    },
    filterSuppliers () {
      if (!this.isRfqToOemGen && !this.isExistRequestBestPrice) {
        return {}
      }

      let order = {
        'OEM-GEN': 0,
        'OEM-PAR': 1,
        'OEM-ALT/AFTM': 2,
        'OEM-ALT': 3,
        'AFTM/USED': 4,
        'CERT-AFTM': 5,
        AFTM: 6,
        USED: 7,
        RECO: 8,
      }
      let orderedSuppliers = _.sortBy(this.rfq.suppliers, [
        s => order[s.type],
        s => s.name
      ])
      return orderedSuppliers
    },
    formatDate(value) {
      if (!value) {
        return ''
      }
      return moment(value).format('DD/MM/YYYY || hh:mmA')
    },
    isEmpty(v) {
      return _.isEmpty(v)
    },
    elementStyle(id) {
      let obj = {
        width: this.getWidthForElement(id) + 'px',
        height: id == 'additional-info' ? 'auto' : this.getHeightForElement(id) + 'px',
        paddingRight: this.getPaddingForElement(id, 'right'),
        paddingLeft: this.getPaddingForElement(id, 'left'),
        paddingTop: this.getPaddingForElement(id, 'top'),
        paddingBottom: this.getPaddingForElement(id, 'bottom'),
      }
      if (id == 'supplier-rfq-view-part-list-column') {
        obj.left = this.getWidthForElement('supplier-rfq-view-line-column') + 'px'
      }
      // if (id === 'supplier-rfq-view-line-column' || id === 'supplier-rfq-view-part-list-column' || id === 'supplier-rfq-view-part-number-column' || id === 'supplier-rfq-view-qty-column' || id === 'supplier-rfq-view-rrp-column') {
      //   obj.left = this.getLeftPosition(id)
      //   obj.backgroundColor = 'rgb(227, 228, 231) !important'
      // }
      return obj
    },
    getWidthForElement(id) {
      if (this.columnWidths[id]) {
        return this.columnWidths[id]
      }
      return 0
    },
    getHeightForElement(id) {
      if (this.columnHeight[id]) {
        return this.columnHeight[id]
      }
      return 0
    },
    getPaddingForElement(id, type) {
      if (this.columnPadding?.[id]?.[type]) {
        return this.columnPadding[id][type]
      }
      return 0
    },
    getWidth(id) {
      let el = document.getElementById(id)
      return el.clientWidth
    },
    getHeight(id) {
      let el = document.getElementById(id)
      let heigth = el.clientHeight
      if (id == 'additional-info') {
        heigth = document.getElementById('sticky-additional-info').clientHeight
        heigth += document.getElementById('supplier-rfq-view-thead-wrapper').clientHeight
      }
      return heigth
    },
    getPadding(id) {
      let el = document.getElementById(id)
      return {
        left: window.getComputedStyle(el, null).getPropertyValue('padding-left'),
        top: window.getComputedStyle(el, null).getPropertyValue('padding-top'),
        right: window.getComputedStyle(el, null).getPropertyValue('padding-right'),
        bottom: window.getComputedStyle(el, null).getPropertyValue('padding-bottom'),
      }
    },
  },
  computed: {
    ...mapGetters({
      companyInfo: 'currentCompany/getDetails',
      isMultipleLocations: 'settings/isMultipleLocations',
    }),
    isExistRequestBestPrice(){
      return ((this.rfq?.secondRequestBestPrice === true || this.rfq?.secondRequestBestPrice === false) || (this.rfq?.thirdRequestBestPrice === true || this.rfq?.thirdRequestBestPrice === false))
    },
    isHasPreviousNbrs() {
      return !_.isEmpty(this.rfq.supplierPreviousQuoteNumbers)
    },
    isDisabledFields: function () {
      return (this.rfq.dueCountdown == '-1' && this.isNewStatus && !this.isRfqToOemGen) || this.isLockedRfq
    },
    isRfqToOemGen () {
      return this.rfq.partsType === 'OEM-GEN'
    },
    isRfqToOemPar () {
      return this.rfq.partsType === 'OEM-PAR'
    },
    isRfqToOemAlt() {
      return this.rfq.partsType === 'OEM-ALT'
    },
    isRfqToUsed () {
      return this.rfq.partsType === 'USED'
    },
    isRfqToAftm () {
      return this.rfq.partsType === 'AFTM'
    },
    isRfqToCertAftm () {
      return this.rfq.partsType === 'CERT-AFTM'
    },
    isRfqToReco () {
      return this.rfq.partsType === 'RECO'
    },
    isShowOePartNumberColumn() {
      return (this.isRfqToAftm || this.isRfqToOemPar || this.isRfqToOemAlt || this.isRfqToCertAftm)
    },
  }
}
</script>

<style>
div.supplier-selected-column:after,
div.supplier-selected-column:before,
div.supplier-selected-column:hover:after,
div.supplier-selected-column:hover:before {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
}

div.supplier-selected-column:before {
  top: 0;
  border: 2px solid #29BBC1;
  /*height: 125px;*/
  height: 100%;
  z-index: 23;
}

div.supplier-selected-column {
  cursor: pointer;
}
#sticky-additional-info .quote-nbr label {
  font-size: 13px !important;
}
</style>
<style scoped>
.supplier-icon-ps-tooltip >>> .tooltip-inner{
  border-radius: 10px 10px 10px 0 !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-left >>> .tooltip-inner{
  border-radius: 10px 10px 0 10px !important;
}
.supplier-icon-ps-tooltip-error >>> .tooltip-inner{
  max-width: 215px;
}
.supplier-icon-ps-tooltip-error.bs-tooltip-left  >>> .tooltip-inner{
  max-width: 215px;
}
.supplier-icon-ps-tooltip.bs-tooltip-right{
  top: -20px !important;
  left: -14px !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-left{
  top: -20px !important;
  left: 18px !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-left.non-reg-tooltip {
  top: -58px !important;
  left: 9px !important;
}
.supplier-icon .bx{
  font-size: 27px;
  opacity: 1 !important;
}
.vehicle-details-information-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.vehicle-details-information-block p {
  margin-bottom: 0;
  font-weight: bold;
  color: #1C1F39;
  margin-right: 10px;
  margin-left: 20px;
  padding-top: 7px;
}

.sticky-rfq-view-header .disabled-stock-select {
  opacity: 0.7 !important;
  cursor: default !important;
}
.part-list-company-color{
  height: 5px;
  width: 80%;
  background: #083d77;
  border-radius: 5px;
  position: absolute;
  bottom: 0;
  left: 9px;
}

.sticky-rfq-view-header .sticky-rfq-view-header-item {
  background-color: rgba(27,30,56,0.12) !important;
  height: 127px;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
  padding: 26px 15px 10px 15px;
  color: #000000;
  width: 180px;
  cursor: pointer;
}

.sticky-rfq-view-header {
  background-color: white;
  display: flex;
}

.supplier-name {
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  min-height: 54px;
  margin-bottom: 10px;
}

.supplier-type {
  color: #1C1F39;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}

.rfq-view-additional-info {
  background-color: white;
  padding-top: 15px;
  padding-bottom: 15px;
}

.border-for-paint-code {
  animation-name: flashing;
  animation-timing-function: cubic-bezier(0.03, 0.25, 0.32, 1.28);
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.sticky-rfq-view-header .sticky-rfq-view-header-item  span{
  background-image: url(data:image/svg+xml;base64,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);
  height: 16px;
  width: 8px;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}


#supplier-rfq-view-thead-wrapper {
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}

#supplier-rfq-view-thead-wrapper::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}

</style>

<style scoped>
.blinking-green {
  animation-name: blinking-green;
  animation-duration: 4s;
  font-size: 20px;
  color: white;
  animation-iteration-count: infinite;
  animation-delay: 250ms;
  cursor: pointer;
  position: absolute;
  top: 6px;
  right: 21px;
}
@keyframes blinking-green {
  20% {
    color: #0cb458;
    opacity: 1;
  }
  80% {
    color: #0cb458;
    opacity: 1;
  }
}

.quote-number-menu {
  width: 138px;
  position: absolute;
  /*border: 1px solid #fff;*/
  z-index: 999999;
  padding-top: 7px;
  padding-bottom: 7px;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
  border-radius: 3px;
  text-align: left;
  background: #fff;
  overflow: auto;
  max-height: 275px;
  top: 35px;
}

.quote-number-close {
  display: none;
  font-size: 14px;
  margin-top: 1px;
  line-height: 14px;
}

.quote-number-close:hover {
  color: red;
}

.quote-number-menu-item {
  min-height: 31px;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 16px !important;
  padding: 7px 15px;
}

.quote-number-menu-item:hover {
  border-bottom: 1px solid #DCDCDC;
  cursor: pointer;
  background-color: rgba(41, 187, 193, 0.1);
  color: #79B1BB;
  font-weight: bold;
}

.quote-number-menu-item:hover .quote-number-close {
  display: inline-block;
}

.paint-code-input {
  position: relative;
}

.paint-code-placeholder {
  position: absolute;
  top: 9px;
  left: 15px;
  font-size: 10px;
  font-weight: bold;
  color: black;
  animation-name: paint-code-placeholder;
  animation-timing-function: cubic-bezier(0.03, 0.25, 0.32, 1.28);
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes paint-code-placeholder {
  50% {
    color: #29bbc1;
  }
}

/* paint-code-placeholder {
  50% {
    text-shadow: #79B1BB 1px 0 3px;
  }
} */

@media screen and (max-width: 576px) {
  .vehicle-details-block {
    width: 100%;
    margin: 15px 0 0 0;
  }
  .additional-info {
    flex-direction: column !important;
    width: 100% !important;
    align-items: flex-start !important;
  }
}

</style>
